import Price,{ defaultCurrencySymbol, formatPrice }                                                                                from "components/Price/Price"
import React, { Component, useState }                                                                 from "react"
import { Redirect }                                                                                   from "react-router"
import { Link, withRouter }                                                                           from "react-router-dom"
import { Table, Menu, Input, Label, Button, Checkbox, Form, Segment, Loader, Modal, Icon, Container,Dropdown } from "semantic-ui-react"
import store                                                                                          from "store"
import customerStore                                                                                  from "stores/customerStore"
import { observer }                                                                                   from "mobx-react"
import $fetch                                                                                         from "sdk/$fetch"
import shop                                                                                           from "shop/shop"
import settingStore                                                                                   from "stores/settingStore";
import useQuery                                                                  from "../../useQuery";

let didRun = false

import BudgetManager      from "./BudgetManager";
import CustomerDetailPage from "./CustomerDetailPage";
import PowerUsersTable    from "./PowerUsersTable";
import SortimentManager   from "./SortimentManager";
import { select } from "notie"

const timeSpanTypes = {
  TS_CART: 0,
  TS_DAILY: 1,
  TS_WEEKLY: 2,
  TS_MONTHLY: 3,
  TS_QUARTER: 4,
  TS_YEAR: 5,
  TS_FIXED: 6,
  TS_FOREVER: 7,
}

const timeSpanNames = {
  0: "Warenkorb",
  1: "Tag",
  2: "Woche",
  3: "Monat",
  4: "Quartal",
  5: "Jahr"
}

const DEFAULT_MAX = 100;
const DEFAULT_TIMESPAN = timeSpanTypes.TS_CART;

const CustomerAccountsModal = ( { open, handId, customer = {}, customerId, onClose } ) => {

  const [loading, setLoading] = useState()
  const [accounts, setAccounts] = useState()
  

  React.useEffect( () => {
    async function load() {
      setLoading( true )
      const data = await shop.fetch( `/shop/rest/users/data?start=0&count=100&filter=${encodeURIComponent( JSON.stringify( { customer_id: customerId } ) )}` )
      setAccounts( data )
    }

    customerId && load()
  }, [customerId] )

  return <Modal open={open}>
    <Modal.Header>
      <div className="flex flex-row items-center justify-between">
        <div>{customer.title}</div>
        <Button onClick={onClose} icon={"close"} basic circular/>
      </div>
    </Modal.Header>
    <Modal.Content>
      <pre>{JSON.stringify( accounts, null, 2 )}</pre>
    </Modal.Content>
    <Modal.Actions>
      <Button onClick={onClose}>OK</Button>
    </Modal.Actions>
  </Modal>
}


const CustomerBudgetModal = ( { open, customer = {}, customerId, onClose } ) => {

  const [loading, setLoading] = useState()
  const [costCentres, setCostCentres] = useState()

  React.useEffect( () => {
    async function load() {
      setLoading( true )
      // THOMAS: 19227 / 18835 / 18769 /  19087 sind aktuell mit kostenstellen versehen
      const data = await shop.fetch( `/shop/rest/costcentre/data?start=0&count=120&customer=${customerId}` )
      setCostCentres( data )
    }

    customerId && load()
  }, [customerId] )

  return <Modal open={open}>
    <Modal.Header>
      <div className="flex flex-row items-center justify-between">
        <div>{customer.title}</div>
        <Button onClick={onClose} icon={"close"} basic circular/>
      </div>
    </Modal.Header>
    <Modal.Content>
      <BudgetManager costCentres={costCentres} loading={loading}/>
    </Modal.Content>
    <Modal.Actions>
      <Button onClick={onClose}>OK</Button>
    </Modal.Actions>
  </Modal>
}

@withRouter
@observer
export default class BudgetAccountSelection extends Component {

  state = {
    size: false,
    customerId: false,
    customers: [],
    loadingRestore: true,
    query: "",
    ready: false,
    buttonBudgetdisabled: false,
    budgetCustomer: [],
    rules: [],
    selectCheckAll: false
  }

  async componentWillMount() {
    this.loadMore()
    if ( didRun ) return this.setState( { loading: false, loadingRestore: false } )
    didRun = true

    const { customer } = shop.session
    const { restoreId } = customerStore
    if ( restoreId && !customer ) {
      console.log( "Set CUSTOMER FROM RESTORE TOKEN" )
      const response = await customerStore.setCustomer( restoreId )
      console.log( "CUSTOMER SET", response )
      if ( response ) {
        this.setState( { loading: false, loadingRestore: false, customerId: restoreId } )
        return
      }
    }
    this.setState( { loading: false, loadingRestore: false } )
  }

  handleSelect = async ( { customer } ) => {
    console.log( "customer", customer )
    $fetch.clear()
    try {
      store.set( `ihand-customer-${customer.map_id}`, customer )
      await customerStore.setCustomer( customer.map_id )
      const mode = settingStore.get( "orderMode" )
      if ( mode === "MODE_PREORDER" ) {
        shop.cart.setExtra( "preorder", true )
      } else {
        shop.cart.setExtra( "preorder", false )
      }
      shop.cart.setExtra( { orderMode: mode } )
      this.props.history.push( this.props.to || "/" )
      shop.toast( `${translate( "Login erfolgreich" )}`, "success" )
    }
    catch (err) {
      shop.toast( `${translate( "toast.CUSTOMER_SELECTION_ERROR" )} ${err}` )
    }
  }

  loadMore = ( count = 12 ) => {
    this.setState( { ready: false, loading: true } )
    const { query } = this.state
    shop.fetch( `/shop/rest/data/customers/search?title=${encodeURIComponent( `%${query}%` )}&count=${count}&start=${0}` ) // pre-urlencoded % = %25
        .then( data => {
          const { size, result } = data
          this.handleResult( { size, customers: result, query } )
          this.setState( { ready: true, loading: false } )
        } )
        .catch( error => {
          this.setState( { error } )
          shop.toast( translate( "toast.SESSION_CLOSED" ) )
          console.error( "Error fetching customers", error )
        } )
  }

  handleResult = ( { size, customers, query } ) => {
    this.setState( { ready: true, size, customers, query } )
  }

  componentDidMount() {
    customerStore.get( { count: 30 } )
  }

  handleCustomerSelect = (budgetCustomer) => {
    console.log(budgetCustomer);
    this.setState({budgetCustomer});
  }

  handleBudget = async ( { customer } ) => {
    this.setState( { showBudgetModal: true, customer, customerId: customer.map_id } )
  }

  handleAccounts = async ( { customer } ) => {
    this.setState( { showAccountModal: true, customer, customerId: customer.map_id } )
  }
  handleSelectAllCustomer = (selectCheckAll,budgetCustomer) => {
    if(selectCheckAll == true){
      console.log("selectCheckAll", selectCheckAll)
      this.setState({selectCheckAll: false})
      selectCheckAll = this.state.selectCheckAll
      console.log("selectCheckAll", selectCheckAll)
      this.setState({budgetCustomer:[]})
    }
    else{
      console.log("selectCheckAll", this.state.selectCheckAll)
      this.setState({selectCheckAll: true})
      selectCheckAll = this.state.selectCheckAll
      console.log("selectCheckAll", this.state.selectCheckAll)
    }
  }
  handleDeselectAllCustomer = (selectCheckAll,budgetCustomer) => {
    this.setState({selectCheckAll: false})
    selectCheckAll = this.state.selectCheckAll
    selectCheckAll =  false
    this.setState({budgetCustomer:[]})
    budgetCustomer = []
  }

  render() {
    const { params } = this.props.match
    const { session } = shop
    const customerId = params.customerId
    const { size, ready, customers, loadingRestore, loading, showBudgetModal, showAccountModal } = this.state
    const searchResult = customers
    const useMore = size > customers.length


    if ( !session ) return <Redirect to={"/login"}/>
    if ( !session.handUser ) return <Redirect to={"/login"}/>

    if ( loadingRestore ) return <Segment>
      <div className="pa3"><Loader active/></div>
    </Segment>

    if ( customerId ) return <CustomerDetailPage onSelect={this.handleSelect}/>
    const tblName = shop.session.handUser.extras.selections

    return <div className="w-100">
      <CustomerBudgetModal open={showBudgetModal} customer={this.state.customer} customerId={this.state.customerId} onClose={() => {
        this.setState( { showBudgetModal: false, customerId: false, customer: false } )
      }}/>

      <CustomerAccountsModal open={showAccountModal} customer={this.state.customer} customerId={this.state.customerId} onClose={() => {
        this.setState( { showAccountModal: false, customerId: false, customer: false } )
      }}/>

      <div className="bg-white pv5">
        <Container>
          <div className="flex flex-row justify-between items-center">
            <div className="f2 b">{translate( "Verwaltung" )}</div>
            <div>
              <div>
                {/*<Link className="pb1 db" to={`/account/`}><Icon name={"chevron left"}/> {translate( "Konto" )}</Link>*/}
                <Button basic as={Link} to={"/account/"}>{translate( "Weiter" )}</Button>
              </div>
            </div>
          </div>
        </Container>
      </div>

      <div className="pv5 bg-silver">
        <Container>
          <h2 className={"b"}>{translate( "Stellvertreter" )} </h2>
          <PowerUsersTable hideColRep hideColContact/>
        </Container>
      </div>

      <div className="pv5 bt bb b--light-gray bg-white">
        <Container>
          <section className="">
            <h2 className="b">{translate( "Sortiment" )} {tblName}</h2>
            <SortimentManager loading={loading} customerId={customerId}/>
          </section>
        </Container>
      </div>


      <div className="pv5">

        <Container>
        <div className="rowBudget">
          <div className="columnBudget">
            <table className="h2Header">
              <tr>
              </tr>
              <tr>
                <td><h2  className={"b"}>{translate( "Kunden" )}</h2></td>
                <td><h2  style={{ textAlign:"right"}} className={"b"}>{translate( "Budgetverwaltung")}</h2></td>
              </tr>
            </table>
          </div>
        </div>
          {/*<h2 style={{ width:"50%" }} className={"b"}>{translate( "Kunden" )}</h2> <h2  style={{ textAlign:"right", width:"50%" }} className={"b"}>{translate( "Budgetverwaltung" )}</h2>*/}
          <div className="pb2">
            <AccountSearch loading={loading} handleDeselectAllCustomer={this.handleDeselectAllCustomer} onChange={this.handleResult} budgetCustomer={this.state.budgetCustomer}/>
          </div>
          {/*<pre>{JSON.stringify( customers, null, 2 )}</pre>*/}
          {!loading && <div className="">
            {size > 0 && <TableAccounts
              onAccounts={this.handleAccounts}
              onSelect={this.handleSelect}
              onBudget={this.handleBudget}
              handleSelectAllCustomer={this.handleSelectAllCustomer}
              onCustomerSelect={this.handleCustomerSelect}
              budgetCustomer={this.state.budgetCustomer}
              selectCheckAll={this.state.selectCheckAll}
              customers={searchResult}
              to={shop.locationAfterLogin || this.props.to || "/home"}/>}
            {/*<TableAccounts onSelect={this.handleSelect} customers={customers} to={this.props.to || "/home"}/>*/}
            {(ready && searchResult.length === 0) && <div className="pa3 tl">{translate( "keine Kunden gefunden" )}</div>}

            {useMore && <div className="pv3 tc"><Button loading={loading} onClick={() => {
              this.loadMore( 500 )
            }
            }>{translate( "mehr" )}</Button></div>}
            <div className="fl">
              <Button as={Link} to={"/account/"} basic size="small">{translate( "back" )}</Button>
            </div>
          </div>}
        </Container>

      </div>

    </div>
  }
}

class AccountSearch extends Component {

  constructor(props) {
    super(props);

    console.log('as props',props);

    this.state = {
      value: "",
      error: false,
      loading: false,
      openBudget: false,
      showNewRule: false,
      setShowNewRule: false,
      buttonBudgetdisabled: true,
      openInfo: false,
      budgetCustomer: props.budgetCustomer,
      selectCheckAll: props.selectCheckAll
    }
  }

  search( value, page = 1, count = 12 ) {
    this.setState( { loading: true } )
    let start = (page - 1) * count
    //shop.fetch( `/shop/rest/data/customers/search?title=${encodeURIComponent(`%${query}%`)}&count=${500}&start=${0}` )
    shop.fetch( `/shop/rest/data/customers/search?title=${encodeURIComponent( `%${value}%` )}&count=${count}&start=${start}` ) // pre-urlencoded % = %25
        .then( data => {
          console.log( { data } )
          const { size, result } = data
          this.props.onChange && this.props.onChange( { size, customers: result, query: value } )
          this.setState( { loading: false } )
        } )
        .catch( error => {
          this.setState( { error } )
          shop.toast( translate( "toast.SESSION_CLOSED" ) )
          console.error( "Error fetching customers", error )
        } )
  }

  reset = () => {
    this.props.onChange && this.props.onChange( { size: false, customers: [] } )
    this.setState( { value: "" } )
    this.search( "" )
  }

  handleChange = e => {
    let value = e.target.value
    this.setState( { value } )
    if ( value && value.length >= 3 ) {
      this.search( value )
    } else {
      this.props.onChange && this.props.onChange( { size: false, customers: [] } )
    }
  }

  postBudget = async (deftimespan,defmaxVal,changedTimeValue,changedMaxValue) => {
    if ( this.state.loading ) return null
    this.setState( { "loading": true } )
    const timeSpan = changedTimeValue || deftimespan
    const maxValue = changedMaxValue || defmaxVal
    var response = []
    var rules = []
    var test = []

    //console.log('save rules',this.props.budgetCustomer.length);
    if(this.props.budgetCustomer.length === 0){
      shop.toast( `${translate( "ACHTUNG: KEINE KUNDEN AUSGEWÄHLT!" )}`)
    }
    else{
      for(var j = 0; j < this.props.budgetCustomer.length;j++){
        response = await shop.fetch( `/shop/rest/costcentre/budgets?costcentre=${this.props.budgetCustomer[j]}`, {
          method: "POST",
          body: JSON.stringify( [...rules, { "name": "Budget", "message": "budget.BUDGET_DEFAULT_REACHED", "costcentre": `${this.props.budgetCustomer[j]}`, "maxValue": maxValue, "expression": "", "timeSpan": timeSpan }] )
        } )
      }
      shop.toast( `${translate( "Budget bei ") + this.props.budgetCustomer.length + translate(" Kunden erfolgreich hinterlegt." )}`)
      this.props.handleDeselectAllCustomer(this.props.budgetCustomer)
    }
    this.setState({budgetCustomer : []})
    this.setState({selectCheckAll: false})
    //this.props.budgetCustomer = this.state.budgetCustomer
    //console.log("response",this.props.budgetCustomer)
    
    /*setForm( {
               maxValue: DEFAULT_MAX,
               timeSpan: DEFAULT_TIMESPAN
             } )*/
    this.setState({ loading: false });
    
    return response
  }

  render() {
    const { value, loading, error,openBudget,openInfo,showNewRule,setShowNewRule,buttonBudgetdisabled,disabled } = this.state
    const timeSpanTypes = {
      TS_CART: 0,
      TS_DAILY: 1,
      TS_WEEKLY: 2,
      TS_MONTHLY: 3,
      TS_QUARTER: 4,
      TS_YEAR: 5,
      TS_FIXED: 6,
      TS_FOREVER: 7,
    }
    
    const timeSpanNames = {
      0: "Warenkorb",
      1: "Tag",
      2: "Woche",
      3: "Monat",
      4: "Quartal",
      5: "Jahr"
    }
    
    const DEFAULT_MAX = 100;
    const DEFAULT_TIMESPAN = timeSpanTypes.TS_CART;
    var changedBudgetMaxValue = 0;
    var changedBudgetTimeValue = 0;
    //console.log("timespantypes: ", this.props.budgetCustomer)

    return (
      <div className="AccountSearch">
          
  {/*<Table compact style={{border: "1px", width:"50%"}}>

<Table.Header>
  <Table.Row style={{ display: "flex" }}>
        
  <Table.HeaderCell><Input className="mr2" value={value} icon="search" loading={loading} placeholder={translate( "Kunde" )} onChange={this.handleChange}/></Table.HeaderCell>
  <Table.HeaderCell><Button className="dib " onClick={this.reset} basic icon={"close"}/></Table.HeaderCell>
        </Table.Row></Table.Header></Table>

         <Table compact style={{border: "1px"}}>

<Table.Header>
  <Table.Row style={{ display: "flex" }}>
        
  <Table.HeaderCell><Button basic style={{}} onClick={() => this.setState( {openBudget: true} )}>{translate( "Budget für alle Kunden (oder Kliniken) bearbeiten" )}</Button></Table.HeaderCell>
  <Table.HeaderCell style={{textAlign:"right"}}><Button className="dib " style={{}} basic icon={"info"} onClick={() => this.setState( {openInfo: true} )}/></Table.HeaderCell>
        </Table.Row></Table.Header></Table> */}


        <div className="rowBudget">
  <div className="columnBudget">
    <table>
      <tr>
      </tr>
      <tr>
        <td><Input className="mr2" value={value} icon="search" loading={loading} placeholder={translate( "Kunde" )} onChange={this.handleChange}/><Button className="dib " onClick={this.reset} basic icon={"close"}/></td>
        <td></td>
      </tr>
    </table>
  </div>
  <div className="columnBudget">
    <table style={{ textAlign:"right" }}>
      <tr>
      </tr>
      <tr>
        <td></td>
        <td style={{ textAlign:"right" }} ><Button basic style={{}} onClick={() => this.setState( {openBudget: true} )}>{translate( "Budget für alle Kunden (oder Kliniken) bearbeiten" )}</Button><Button className="dib " style={{}} basic icon={"info"} onClick={() => this.setState( {openInfo: true} )}/></td>
      </tr>
    </table>
  </div>
</div>
        
        <Modal 
					closeIcon={<Icon name="close" />}
					open={openInfo}
          style={{ top: '20%'}}
					onClose={() => {
						this.setState( {openInfo: false} )
					}}
					size="tiny">
            
					<Modal.Header         style={{
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          }}>
          {translate( "Budget verwalten" )}</Modal.Header>
          <Modal.Content>
            
        {translate("Um eine Budgetregel für mehrere Kunden anzulegen, klicken Sie bitte auf die Checkboxen auf der rechten Seite.")}
        </Modal.Content>
        </Modal>

        <Modal 
					closeIcon={<Icon name="close" />}
					open={openBudget}
          style={{ top: '40%', width: '40%',}}
					onClose={() => {
						this.setState( {openBudget: false} )
					}}
					size="tiny">
            
					<Modal.Header         style={{
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          }}>
          {translate( "Budget verwalten" )}</Modal.Header>
					<Modal.Content>
          {/*this.props.budgetCustomer.length == 0 && 
          <h4>ACHTUNG: KEINE KUNDEN AUSGEWÄHLT!</h4>*/}
        <h3>{translate( "Regeln" )}</h3>
        <Table>
          
          
          {/*!showNewRule && <Table.Row>
            <Table.Cell colSpan={3}>
              <div className="flex flex-row items-center">
                <Button onClick={() => {
                  this.setState( {setShowNewRule: true} )
                }} icon={"plus"} primary/>
                <div className="pl2 black-70 f6">
                  {translate( "Budgetregel hinzufügen" )}
                </div>
              </div>
            </Table.Cell>
              </Table.Row>*/}
          
          {!showNewRule && <Table.Row>
            <Table.Cell>
              <div className="f7 black-70">{translate("max. Budget")} ({defaultCurrencySymbol})</div>
              <Input
                defaultValue={DEFAULT_MAX}
                type="number" placeholder={translate("Budget")} onChange={( e ) => {
                const maxValue = e.currentTarget.value
                changedBudgetMaxValue = e.currentTarget.value
                //append( { maxValue } )
              }}/>
            </Table.Cell>
            
            <Table.Cell>
              <div className="f7 black-70">pro</div>
              <Dropdown
                selection
                defaultValue={DEFAULT_TIMESPAN}
                onChange={( e, x ) => {
                  console.log( e, x )
                  changedBudgetTimeValue = x.value
                  //append( { timeSpan: x.value } )
                }}
                options={[{
                  value: timeSpanTypes.TS_CART, text: translate( "Warenkorb" ), key: "Warenkorb"
                }, {
                  value: timeSpanTypes.TS_WEEKLY, text: translate( "Woche" ), key: "Woche"
                }, {
                  value: timeSpanTypes.TS_MONTHLY, text: translate( "Monat" ), key: "Monat"
                }, {
                  value: timeSpanTypes.TS_QUARTER, text: translate( "Quartal" ), key: "Quartal"
                }, {
                  value: timeSpanTypes.TS_YEAR, text: translate( "Jahr" ), key: "Jahr"
                },]}/>
            </Table.Cell>
            <Table.Cell textAlign={"right"}>
              <div className="f7 black-70">{translate( "Regel speichern" )}</div>
              <Button
                style={{ marginRight: 0 }}
                loading={loading}
                size={"small"} primary onClick={() => {
                  this.postBudget(DEFAULT_TIMESPAN,DEFAULT_MAX,changedBudgetTimeValue,changedBudgetMaxValue); this.setState({budgetCustomer : []}); 
              }}>{translate( "speichern" )}</Button>
            </Table.Cell>
          </Table.Row>}
        
        </Table>
      
      </Modal.Content>
      <Modal.Actions>
        <Button size={"tiny"} basic onClick={() => this.setState( {openBudget: false} )}>{translate( "Ok" )}</Button>
      </Modal.Actions>
				</Modal>
        {error && <Redirect to={"/login/"}/>}
      </div>
    )
  }
}

export const TableAccounts = ( { to, onBudget, onAccounts, onSelect,handleSelectAllCustomer, customers = [],budgetCustomer = [], onCustomerSelect = false, selectCheckAll = true } ) => (
  
  <Table compact>

    <Table.Header>
      <Table.Row>
        <Table.HeaderCell>{translate( "Kundennummer" )}</Table.HeaderCell>
        <Table.HeaderCell>{translate( "Name" )}</Table.HeaderCell>
        {/*<Table.HeaderCell>{translate( "Tel" )}</Table.HeaderCell>*/}
        <Table.HeaderCell>{translate( "Land" )}</Table.HeaderCell>
        <Table.HeaderCell>{translate( "PLZ" )}</Table.HeaderCell>
        <Table.HeaderCell>{translate( "Ort" )}</Table.HeaderCell>
        <Table.HeaderCell>{translate( "E-Mail" )}</Table.HeaderCell>
        <Table.HeaderCell>&nbsp;</Table.HeaderCell>
        {selectCheckAll == true && <Table.HeaderCell><Checkbox defaultChecked={selectCheckAll} onClick={() => { handleSelectAllCustomer(selectCheckAll,budgetCustomer) }}></Checkbox></Table.HeaderCell>}
        {selectCheckAll == false && <Table.HeaderCell><Checkbox defaultChecked={selectCheckAll} onClick={() => { handleSelectAllCustomer(selectCheckAll,budgetCustomer) }}></Checkbox></Table.HeaderCell>}
      </Table.Row>

    </Table.Header>

    <Table.Body>
      {customers.map( customer => {
        var checkboxChecked = 0;
        var notPushed = 0
        var selectedForCheck = 0
        console.log("selectcheckall",selectCheckAll)
        if(selectCheckAll == true){
          console.log("alle gewählt")
          checkboxChecked = 1
          for(var i = 0; i<budgetCustomer.length;i++){
            if(customer.map_id == budgetCustomer[i]){
              notPushed = 1
            }
          }
          if(notPushed == 0 && customer.map_id != ''){
            budgetCustomer.push(customer.map_id)
          }
          selectedForCheck = 1
          console.log("selectedforcheck:", selectedForCheck)
        }
        else if(selectedForCheck == 1 && selectCheckAll == false ){
          budgetCustomer = []
          selectedForCheck = 0
          console.log("Kommen wir hier rein?", budgetCustomer, " ", selectedForCheck)
        }
        console.log("budgetcustomer gepushed: ", budgetCustomer)
        /*for(var k = 0; k<budgetCustomer.length;k++){
          if(customer.map_id == budgetCustomer[k]){
            checkboxChecked = 1;
          }
          if(selectCheckAll == true){
            if(selectCheckAll == true && checkboxChecked == 1){
              checkboxChecked = 1
            }
            else{
              checkboxChecked = 1;
            }
            console.log("Kommen wir hier rein? TRUE?", selectCheckAll)
            for(var i = 0; i<budgetCustomer.length;i++){
              if(customer.map_id == budgetCustomer[i]){
                notPushed = 1
              }
            }
            if(notPushed == 0 && customer.map_id != ''){
              budgetCustomer.push(customer.map_id)
            }
          }
          else{
            budgetCustomer = []
          }
        }*/
        console.log(budgetCustomer)
        return (
          <Table.Row key={customer.map_id}>
            <Table.Cell>{customer.map_id}</Table.Cell>
            <Table.Cell>{customer.title || customer.name}</Table.Cell>
            {/*<Table.Cell>{customer.phone}</Table.Cell>*/}
            <Table.Cell>{customer.country}</Table.Cell>
            <Table.Cell>{customer.pcode}</Table.Cell>
            <Table.Cell>{customer.city}</Table.Cell>
            <Table.Cell>{customer.email}</Table.Cell>
            <Table.Cell>
              <div className="flex flex-row justify-end">
                <Button onClick={() => {
                  onSelect( { customer } )
                }} basic size={"tiny"}>{translate( "Anmelden" )}</Button>
                <Button basic title={translate( "accounts" )} as={Link} to={`/login/accounts/${customer.map_id}`} size={"tiny"} icon={"chevron right"}/>
              </div>
            </Table.Cell>
            <Table.Cell>
              <div className="flex flex-row justify-end">
                {checkboxChecked == 1 && customer.map_id != '' && <Checkbox defaultChecked={selectCheckAll} onClick={() => { 
                    var notPushed = 0
                    for(var i = 0; i<budgetCustomer.length;i++){
                      if(customer.map_id == budgetCustomer[i]){
                        notPushed = 1
                        budgetCustomer.splice(i, 1);
                      }
                      
                    }
                    if(budgetCustomer.length == 0 || notPushed == 0){
                      budgetCustomer.push(customer.map_id)
                    }
                    console.log(budgetCustomer, ' CHECKK 1',budgetCustomer.length, ' cust: ',customer.map_id)
                    //if (onCustomerSelect) onCustomerSelect(budgetCustomer);
                  }}></Checkbox>}

                {checkboxChecked == 0 && customer.map_id != '' && <Checkbox defaultChecked={selectCheckAll} onClick={() => { 
                    var notPushed = 0
                    console.log("Hilfe?",selectCheckAll)
                    for(var i = 0; i<budgetCustomer.length;i++){
                      if(customer.map_id == budgetCustomer[i]){
                        notPushed = 1
                        if(budgetCustomer.length == 1){
                          budgetCustomer.pop()
                        }
                        else{
                          budgetCustomer.splice(i, 1);
                        }
                      }
                    }
                    if(notPushed == 0){
                      budgetCustomer.push(customer.map_id)
                    }
                    console.log(budgetCustomer, ' CHECKK 2',budgetCustomer.length, ' cust: ',customer.map_id)
                    console.log("COSTID???", shop.session)
                    //if (onCustomerSelect) onCustomerSelect(budgetCustomer);
                  }}></Checkbox>}
                  {customer.map_id == '' &&<Checkbox className="disbl" disabled></Checkbox>}
              </div>
            </Table.Cell>
          </Table.Row>
        )
      } )}

    </Table.Body>

  </Table>
)



// WEBPACK FOOTER //
// ./src/components/Budget/BudgetAccountSelection.js